module.exports = __webpack_public_path__ + "static/img/logo2.b7858e83.png";